import { groupsWithCustomFieldsColumns } from '../../../../backend/features/groups/shared/views';
import { defineView } from '@juvare/platform-app/App';
export const groupsWithCustomFieldsView = defineView({
    columns: groupsWithCustomFieldsColumns,
    viewQuery: `SELECT
                    group_cache._id AS id,
                    group_cache.name AS group_name,
                    account_cache.display_name AS group_owner,
                    group_cache.filter_by_columns AS group_filters
                FROM group_cache
                LEFT JOIN account_cache ON group_cache.owner_account_id::UUID = account_cache._id
                WHERE group_cache.filter_based = TRUE AND EXISTS(SELECT 1 FROM unnest(group_cache.filter_by_columns) as item WHERE item LIKE '_dynamic_%');
    `,
    orderByColumn: 'groupName',
});
